import ProductInterface from '../ProductInterface';
import ListhrlyOptions from './ListhrlyOptions';
import { processListhrly } from './listhrlyProcess';

export default function Listhrly() {
  return (
      <ProductInterface
          product = "listhrly"
          ProductOptions = {ListhrlyOptions}
          processProduct = {processListhrly}
      />
  )
} 